
<div class="container mt-4">
  <h3>User Management</h3>
  <p class="text-muted small">Link each SME to a customer and set assigned license count when customer license mode is ASSIGNED.</p>

  <div *ngIf="loading">Loading users...</div>
  <div *ngIf="error" class="text-danger">{{ error }}</div>

  <table class="table table-bordered table-hover align-middle" *ngIf="users.length > 0">
    <thead class="table-light">
      <tr>
        <th>UserID</th>
        <th>User Name</th>
        <th>Login ID</th>
        <th>Role</th>
        <th>Status</th>
        <th>Customer / licenses (SME)</th>
        <th>Change Role</th>
        <th>Change Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of users">
        <td>{{ user.userId }}</td>
        <td>{{ user.username }}</td>
        <td>{{ user.loginid }}</td>
        <td>{{ user.user_type }}</td>
        <td>{{ user.user_status }}</td>
        <td>
          <ng-container *ngIf="user.user_type === 'SME'; else notSme">
            <select
              class="form-select form-select-sm mb-1"
              [(ngModel)]="smeEdits[user.userId].CustomerShortCode"
              [name]="'cust_' + user.userId"
            >
              <option value="">— Select customer —</option>
              <option *ngFor="let c of customers" [value]="c.CustomerShortCode">{{ c.CustomerShortCode }}</option>
            </select>
            <input
              type="number"
              class="form-control form-control-sm mb-1"
              min="0"
              placeholder="Assigned licenses"
              [(ngModel)]="smeEdits[user.userId].assignedLicenses"
              [name]="'alic_' + user.userId"
            />
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              [disabled]="savingSme[user.userId]"
              (click)="saveSmeAssignment(user)"
            >
              {{ savingSme[user.userId] ? 'Saving…' : 'Save' }}
            </button>
          </ng-container>
          <ng-template #notSme>
            <span class="text-muted">—</span>
          </ng-template>
        </td>
        <td>
          <button class="btn btn-sm btn-secondary me-2" (click)="changeRole(user)">Change Role</button>
        </td>
        <td>
          <button class="btn btn-sm" [ngClass]="user.user_status === 'A' ? 'btn-danger' : 'btn-success'"
            (click)="toggleStatus(user)">
            {{ user.user_status === 'A' ? 'I' : 'A' }}
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="card mb-4">
  <div class="card-body">
    <h5 class="card-title">Add New User</h5>

    <form #userForm="ngForm" (ngSubmit)="addUser()">
      <div class="row gy-2">
        <div class="col-md-3">
          <input type="text" [(ngModel)]="newUser.username" name="username" class="form-control" placeholder="Full Name"
            required />
        </div>
        <div class="col-md-3">
          <input type="text" [(ngModel)]="newUser.loginid" name="loginid" class="form-control" placeholder="Login ID"
            required />
        </div>
        <div class="col-md-3">
          <input type="password" [(ngModel)]="newUser.password" name="password" class="form-control"
            placeholder="Password" required />
        </div>
        <div class="col-md-2">
          <select [(ngModel)]="newUser.user_type" name="user_type" class="form-select" required>
            <option value="" disabled selected>Select Role</option>
            <option value="admin">Admin</option>
            <option value="designer">Designer</option>
            <option value="creator">Creator</option>
            <option value="SME">SME</option>
          </select>
        </div>
        <div class="col-md-12">
          <button type="submit" class="btn btn-primary mt-2" [disabled]="userForm.invalid">Add User</button>
        </div>
      </div>
    </form>
  </div>
</div>
